// Feeds max-scroll-depth into the engagement accumulator from a scroll
// container (Phase 2d). Mount on the element that actually scrolls — the
// GeneralLayout inner div (the window/body never scrolls in this app, so a
// window-level listener would read zero). DashAI / other self-scrolling shells
// are not covered.

import { useEffect } from 'react';
import type { RefObject } from 'react';
import { recordScroll } from './engagement';

export function useScrollDepth(ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = () => {
      const denom = el.scrollHeight - el.clientHeight;
      recordScroll(denom > 0 ? (el.scrollTop / denom) * 100 : 0);
    };
    onScroll(); // seed (0 for a fresh/short page)
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [ref]);
}
